// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CarouselRightArrowIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
            <g fill="none">
                <circle cx="30" cy="30" r="28" stroke="#000" strokeOpacity=".15" strokeWidth="4" />
                <circle cx="30" cy="30" r="26" fill="currentColor" fillRule="evenodd" />
                <path
                    fill="#FFF"
                    d="M24.96875,28.9360544 C24.34375,29.4993197 24.34375,30.5006803 24.96875,31.0639456 L34.96875,41.077551 C35.53125,41.6408163 36.46875,41.6408163 37.03125,41.077551 C37.65625,40.5142857 37.65625,39.5129252 37.03125,38.9496599 L28.09375,30 L37.03125,21.0503401 C37.65625,20.4870748 37.65625,19.4857143 37.03125,18.922449 C36.46875,18.3591837 35.53125,18.3591837 34.96875,18.922449 L24.96875,28.9360544 Z"
                    transform="matrix(-1 0 0 1 62 0)"
                />
            </g>
        </svg>
    );
};

export default React.memo(CarouselRightArrowIcon);
